import { render } from "./Gallery.vue?vue&type=template&id=15c33654&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=15c33654&scoped=true&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/ritual/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c33654"]])

export default __exports__